import { Box, Typography } from "@mui/material";
import { Question } from "../../models/types";
import { QuestionnaireBuilderQuestionTitle } from "../../molecules/template-builder/QuestionnaireBuilderQuestionTitle";

type QuestionGroupProps = {
  questions: Question[];
  setSelectedQuestion: (question: Question) => void;
  index: number;
};

export const QuestionGroup = (props: QuestionGroupProps) => {
  const { questions, setSelectedQuestion, index } = props;

  return (
    <Box display="flex" flexDirection="column" gap="16px">
      {questions.map((question, idx) => (
        <QuestionnaireBuilderQuestionTitle
          question={question}
          selected={false}
          onClick={setSelectedQuestion}
          index={index + idx}
          questionGroup
        />
      ))}
    </Box>
  );
};
